import React from 'react';

const ContactMap = () => {
  return (
    <section aria-label="map" className="no-bottom">
      <div className="container-fluid">
        <div className="row p-3-vh">
          <div className="col-md-12">
            <div style={{marginTop:"0px"}}>
            <iframe
                src="https://www.google.com/maps/d/u/0/embed?mid=107SImYAMn_JeYpaREqei6ySulzxPz1c&ehbc=2E312F"
                width="100%"
                height="780"
                style={{
                  border: "none",
                  display: "inline-block",
                  overflow: "hidden",
                  clipPath: "polygon(0 12%, 100% 12%, 100% 100%, 0% 100%)",
                }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactMap;
